module.exports = __webpack_public_path__ + "32e21c56cfb76dc4ade6b732a3d69a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Step Cut Trapezoid.png
// module id = 785
// module chunks = 0